import CommonIFrame from '../atoms/CommonIFrame';

const LTReport = () => {
    return <CommonIFrame src="https://preview--rgm-hub-portal.lovable.app/lt-report" title="LTReport" />;
};

export default LTReport;
